const getLocale = () => {
    return navigator.languages?.[0] || 'en-US'
}

export { getLocale }
